import { TRACKING_SDRN } from '@/constants'
import { PulseEvent } from '@/shared/tracking/pulse-tracker'
export * from './pulse-tracker'

export interface TrackingEvents {
    track: (params: PulseEvent, eventType?: string) => {};
    marketplace?: string;
}

export interface TrackingLoginEventProps extends TrackingEvents {
    email: string;
}

export type TrackingPageviewEventProps = TrackingEvents

export function trackPageViewedEvent ({ marketplace, track }: TrackingPageviewEventProps) {
  const objectProp = {
    '@id': `${TRACKING_SDRN}:${marketplace.toLowerCase()}`,
    '@type': 'Page',
    pageName: document.title,
    pageType: 'homepage',
    text: marketplace,
  }

  track({ type: 'View', object: objectProp, name: 'Page viewed', published: new Date() })
}

export function trackLoginEvent ({ marketplace, email, track }: TrackingLoginEventProps) {
  const objectProp = {
    type: 'EmailContact',
    email,
    '@id': `${TRACKING_SDRN}:${marketplace.toLowerCase()}`,
  }

  track({ type: 'Login', object: objectProp, name: '', published: new Date() })
}
